import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon, SproutIcon } from 'lucide-react';
export function Bridge() {
  return <section className="bg-[#fdf0ec] px-4 py-12 md:py-16" data-id="element-71" data-mp="1y7sqaxeygora">
      <motion.div initial={{
      opacity: 0,
      y: 14
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="mx-auto max-w-3xl text-center" data-id="element-72" data-mp="228cnu23fxudy">
        <SproutIcon className="mx-auto mb-4 h-7 w-7 text-brand-darker" aria-hidden="true" data-id="element-73" data-mp="2bz7c1c08z421" />
        <p className="font-serif text-2xl italic leading-relaxed text-brand-darker md:text-3xl" data-id="element-74" data-mp="2gxin1q2a3klu">
          Seguí leyendo y entendé por qué S.O.S. Lactancia puede darte el mapa
          que necesitás para transitar cada toma con más calma.
        </p>
        <div className="mx-auto my-6 h-px w-28 bg-brand-accent/70" data-id="element-75" data-mp="2pxxaow2ptbsi" />
        <ArrowDownIcon className="mx-auto h-5 w-5 animate-bounce text-brand-darker" aria-hidden="true" data-id="element-76" data-mp="rjm8756uiagq" />
      </motion.div>
    </section>;
}